(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["goose-card-colors"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.gooseCardColorsReady) return;
  window.gooseCardColorsReady = true;
  document.addEventListener('click', event => {
    const button = event.target.closest('.goose-card-colors__choice');
    if (!button) return;
    const picker = button.closest('[data-color-picker]');
    const card = picker.closest('[data-goose-color-card]');
    if (!card) return;
    event.preventDefault();
    event.stopPropagation();
    picker.querySelectorAll('button').forEach(option => option.setAttribute('aria-pressed', String(option === button)));
    picker.querySelector('[data-color-label]').textContent = button.dataset.colorName;
    const reference = picker.querySelector('[data-color-photo-reference]');
    if (reference) {
      reference.textContent = button.dataset.photoReference || '';
      reference.hidden = !button.dataset.photoReference;
    }
    const image = card.querySelector('.gwh-card__image img, .gw-john__card-image img, .gw-john__kit-image img, .card__media .media img, .ghb-card__photo img');
    if (image) {
      image.srcset = button.dataset.colorSrcset;
      image.src = button.dataset.colorImage;
      image.alt = button.dataset.colorAlt;
    }
    card.dataset.colorChosen = button.dataset.colorName;
    const productPath = new URL(picker.dataset.productUrl, location.origin).pathname;
    card.querySelectorAll('a[href]').forEach(link => {
      if (new URL(link.href, location.origin).pathname === productPath) link.href = button.dataset.variantUrl;
    });
    card.querySelectorAll('[data-product-url]').forEach(control => {
      if (control !== picker) control.dataset.productUrl = button.dataset.variantUrl;
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["goose-hatbar-menu-preview"] && !Shopify.designMode) return;
  try {
    function positionHatbarPreview(link){
    const preview=link.querySelector('.goose-hatbar-menu-preview');
    if(!preview)return;
    preview.style.setProperty('--hatbar-preview-offset','0px');
    const bounds=preview.getBoundingClientRect();
    if(!bounds.width)return;
    const screenWidth=document.documentElement.clientWidth;
    const offset=Math.max(16,Math.min(bounds.left,screenWidth-bounds.width-16))-bounds.left;
    preview.style.setProperty('--hatbar-preview-offset',offset+'px');
  }
  document.addEventListener('keydown',event=>{
    if(event.key==='Escape')document.querySelectorAll('.goose-hatbar-menu-link').forEach(link=>link.classList.add('preview-dismissed'));
  });
  ['pointerover','focusin'].forEach(type=>document.addEventListener(type,event=>{
    const link=event.target.closest('.goose-hatbar-menu-link');
    if(link&&!link.contains(event.relatedTarget)){
      link.classList.remove('preview-dismissed');
      positionHatbarPreview(link);
    }
  }));
  window.addEventListener('resize',()=>document.querySelectorAll('.goose-hatbar-menu-link').forEach(positionHatbarPreview));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["goose-hatbar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('goose-hatbar')) customElements.define('goose-hatbar', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.hatHandles = new Set([...this.querySelectorAll('[data-hb-kind="hat"][data-hb-product]')].map(card => card.dataset.hbProduct));
    this.t = JSON.parse(this.querySelector('[data-hb-text]').textContent);
    this.state = {hat:null,band:null,feather:null};
    this.cache = new Map(); this.tokens = {}; this.busy = false; this.locked = false;
    this.querySelectorAll('[data-hb-kind="hat"][data-hb-product]').forEach(button => {
      this.setupWornPreview(button);
      this.updateWornPhoto(button);
    });
    this.addEventListener('click', event => this.onClick(event));
    this.addEventListener('change', event => this.onChange(event));
    this.querySelector('[data-hb-initials]').addEventListener('input', event => {
      event.target.value = event.target.value.replace(/[^a-zA-Z0-9]/g,'').slice(0,3).toUpperCase();
      this.update();
    });
    this.observer = new IntersectionObserver(entries => {
      this.querySelector('[data-hb-mobile]').hidden = !entries[0].isIntersecting || !matchMedia('(max-width:749px)').matches;
    }, {threshold:0});
    this.observer.observe(this);
    this.update();
  }
  disconnectedCallback() { this.observer?.disconnect();this.helpDialogs?.forEach(dialog=>{if(dialog.open)dialog.close();dialog.remove();}); }
  money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'es-MX',{style:'currency',currency:this.dataset.currency,currencyDisplay:'code',maximumFractionDigits:2}).format(cents/100); }
  status(message) { this.querySelector('[data-hb-status]').textContent = message || ''; }
  route(path) { return this.dataset.root.replace(/\/?$/,'/') + path; }
  async product(url, fresh=false) {
    if(!url) throw new Error(this.t.load_error);
    const path = new URL(url, location.origin); path.search=''; path.hash=''; path.pathname=path.pathname.replace(/\.js$/,'')+'.js';
    const key=path.pathname;
    if (!fresh && this.cache.has(key)) return this.cache.get(key);
    const response=await fetch(path.pathname,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error(this.t.load_error);
    const product=await response.json();
    await window.GooseOptions.ready;
    if (!Array.isArray(product.variants)) throw new Error(this.t.load_error);
    this.cache.set(key,product); return product;
  }
  photoColor(value) { return String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,''); }
  setWornPhoto(wrapper, active) {
    const toggle=wrapper.querySelector('[data-hb-worn-toggle]');
    if(!toggle)return;
    active=active&&!toggle.hidden;
    wrapper.toggleAttribute('data-hb-worn-active',active);
    toggle.setAttribute('aria-pressed',String(active));
    const label=active?toggle.dataset.backLabel:toggle.dataset.showLabel;
    toggle.querySelector('[data-hb-worn-label]').textContent=label;
    toggle.setAttribute('aria-label',label+' · '+wrapper.querySelector('.ghb-card>strong').textContent);
  }
  setupWornPreview(button) {
    const photo=button.querySelector('.ghb-card__photo'),wrapper=button.closest('.ghb-preview-card');
    if(!photo.querySelector('[data-hb-worn-preview]'))return;
    let gesture=null,swiped=false;
    photo.addEventListener('touchstart',event=>{
      swiped=false;
      const toggle=wrapper.querySelector('[data-hb-worn-toggle]');
      gesture=event.touches.length===1&&!toggle.hidden?{x:event.touches[0].clientX,y:event.touches[0].clientY,axis:null}:null;
    },{passive:true});
    photo.addEventListener('touchmove',event=>{
      if(event.touches.length!==1){gesture=null;return;}
      if(!gesture)return;
      const dx=event.touches[0].clientX-gesture.x,dy=event.touches[0].clientY-gesture.y;
      if(!gesture.axis){
        if(Math.abs(dy)>16&&Math.abs(dy)>Math.abs(dx)*1.4)gesture.axis='vertical';
        else if(Math.abs(dx)>8&&Math.abs(dx)>Math.abs(dy)*1.15)gesture.axis='horizontal';
      }
      if(gesture.axis!=='horizontal')return;
      if(gesture.preview===undefined)gesture.preview=dx>0||wrapper.hasAttribute('data-hb-worn-active');
      if(gesture.preview){
        if(event.cancelable)event.preventDefault();
        event.stopPropagation();
        if(Math.abs(dx)>=Math.min(30,Math.max(18,photo.clientWidth*.1))){
          this.setWornPhoto(wrapper,dx>0);swiped=true;
        }
      }
    },{passive:false});
    photo.addEventListener('touchend',()=>{gesture=null;},{passive:true});
    photo.addEventListener('touchcancel',()=>{gesture=null;swiped=false;},{passive:true});
    photo.addEventListener('click',event=>{if(swiped){event.preventDefault();event.stopPropagation();swiped=false;}},true);
  }
  updateWornPhoto(button) {
    const preview=button.querySelector('[data-hb-worn-preview]');if(!preview)return;
    const wrapper=button.closest('.ghb-preview-card'),toggle=wrapper.querySelector('[data-hb-worn-toggle]');
    this.setWornPhoto(wrapper,false);
    const photos=preview.wornPhotos||(preview.wornPhotos=JSON.parse(preview.querySelector('[data-hb-worn-photos]').textContent));
    const chosen=button.dataset.hbColor||button.closest('.ghb-preview-card').querySelector('.goose-card-colors__choice[aria-pressed="true"]')?.dataset.colorName;
    const key=chosen?this.photoColor(chosen):preview.dataset.hbDefaultColor,item=photos['*']||photos[key];
    toggle.hidden=!item;
    preview.hidden=!item;if(!item)return;
    let image=preview.querySelector('img');
    if(!image){
      image=document.createElement('img');image.width=600;image.height=600;image.loading='lazy';image.decoding='async';image.draggable=false;
      image.addEventListener('load',()=>{preview.dataset.loaded='true';});
      image.addEventListener('error',()=>{preview.hidden=true;toggle.hidden=true;this.setWornPhoto(wrapper,false);delete preview.dataset.loaded;});
      preview.append(image);
    }
    if(image.getAttribute('src')!==item.src){delete preview.dataset.loaded;image.alt=item.alt;image.src=item.src;}
    if(image.complete&&image.naturalWidth>0)preview.dataset.loaded='true';
  }
  colorPhotos(product,color) {
    const normalize=value=>this.photoColor(value),file=src=>String(src||'').split('?')[0].split('/').pop();
    const colorIndex=product.options.findIndex(option=>/^(color|colour)$/i.test(typeof option==='string'?option:option.name));
    const selected=normalize(color),variants=product.variants.filter(v=>colorIndex<0||normalize(v.options[colorIndex])===selected);
    const primary=variants.find(v=>v.featured_image?.src)?.featured_image?.src;
    // Verified legacy angles without a colour label. New uploads identify their colour in the filename.
    const legacy={"john":{"john-7762797.jpg":"cafe-oscuro","john-1342036.jpg":"cafe-oscuro","john-9479050.jpg":"cafe-oscuro","john-5226264.jpg":"cafe-oscuro","john-3073057.png":"cafe-oscuro"},"rip-wheeler":{"wheeler-2489903.jpg":"cafe-oscuro","wheeler-1017964.jpg":"cafe-oscuro","wheeler-7907863.png":"cafe-oscuro","wheeler-1598996.jpg":"cafe-oscuro","wheeler-2135282.png":"cafe-oscuro","wheeler-5025697.png":"cafe-oscuro","wheeler-cafe-oscuro-01-modelo-frontal.jpg":"cafe-oscuro","wheeler-cafe-oscuro-02-modelo-posterior.jpg":"cafe-oscuro","wheeler-cafe-oscuro-03-interior.jpg":"cafe-oscuro","wheeler-cafe-oscuro-04-vista-frontal.jpg":"cafe-oscuro","wheeler-cafe-oscuro-05-vista-posterior.jpg":"cafe-oscuro"},"dutton-ranch":{"dutton-ranch-3209665.png":"gris-nieve","dutton-ranch-5644656.png":"gris-nieve","dutton-ranch-4555058.png":"gris-nieve"},"campestre":{"campestre-6880572.png":"buckskin","campestre-4672684.png":"buckskin","campestre-5659784.png":"buckskin","campestre-4549631.png":"buckskin"},"king-ranch-100x":{"king-ranch-100x-546904.png":"buckskin","king-ranch-100x-939141.png":"buckskin"},"minnick":{"minnick-3310286.png":"negro","12.png":"negro","14.png":"negro","13.png":"negro"},"beth":{"1_8460bd7b-3c65-45ad-a388-b82ffbe97bf3.png":"cafe-oscuro","5_d59ef001-9b97-4352-9478-4437e3a67507.png":"cafe-oscuro","3_755b9ad6-6630-43de-997e-60b0dfc3eb8a.png":"cafe-oscuro","4_ba0c9007-871f-4161-80d1-a36e808fe6a2.png":"cafe-oscuro"},"marlboro":{"marlboro-9298421.png":"negro","marlboro-8571053.png":"negro","marlboro-397103.jpg":"negro","marlboro-138342.jpg":"negro","marlboro-4113211.png":"negro","marlboro-387502.jpg":"negro"},"cody-j":{"cody-j-4516180.png":"tabaco","cody-j-2249803.png":"tabaco","cody-j-9848044.png":"tabaco","cody-j-7387705.png":"tabaco","cody-j-9023724.png":"tabaco"},"robabastian":{"personalizado-1724385.png":"negro","personalizado-7896782.png":"negro","personalizado-4118569.png":"negro","personalizado-5236962.png":"negro"},"patron":{"patron-3383236.png":"negro","patron-5427884.png":"negro","patron-2378905.png":"negro"},"dakota":{"dakota-2708136.png":"buckskin","dakota-4298205.png":"buckskin","dakota-7265421.png":"buckskin"},"jefe-de-jefes":{"jefe-de-jefes-9876717.png":"negro","jefe-de-jefes-2477506.png":"negro","jefe-de-jefes-1851763.png":"negro","jefe-de-jefes-1347803.png":"negro","jefe-de-jefes-7646908.png":"negro"}};
    const groups=legacy[product.handle]||{};
    const colors=[...new Set(product.variants.map(v=>normalize(v.options[colorIndex])))].filter(Boolean).sort((a,b)=>b.length-a.length);
    const photos=(product.media||[]).filter(m=>m.media_type==='image').filter(m=>{
      const filename=file(m.src),assigned=product.variants.filter(v=>v.featured_image&&(v.featured_image.id===m.id||file(v.featured_image.src)===filename));
      if(assigned.length)return assigned.some(v=>normalize(v.options[colorIndex])===selected);
      if(groups[filename])return groups[filename]===selected;
      const description=normalize(filename+' '+(m.alt||''));
      if(/john-nieve-galeria/.test(description))return selected==='gris-nieve';
      const named=colors.find(c=>('-'+description+'-').includes('-'+c+'-'));
      return named===selected;
    }).map(m=>({src:m.src,alt:m.alt||product.title+' · '+color}));
    if(primary){const i=photos.findIndex(m=>file(m.src)===file(primary));if(i>=0)photos.unshift(photos.splice(i,1)[0]);else photos.unshift({src:primary,alt:product.title+' · '+color});}
    return photos;
  }
  setupPhotos() {
    const state=this.state.hat;if(!state)return;
    this.querySelectorAll('[data-hb-kind="hat"][data-hb-product]').forEach(button=>{
      const wrapper=button.closest('.ghb-preview-card'),photo=button.querySelector('.ghb-card__photo'),old=photo.querySelector('.ghb-photo-track'),nav=wrapper.querySelector('.ghb-photo-nav');
      if(button.dataset.hbProduct!==state.product.handle){if(old){const first=old.querySelector('img');old.replaceWith(first);}delete wrapper.dataset.hbGalleryIndex;if(nav)nav.hidden=true;return;}
      const colorIndex=state.product.options.findIndex(option=>/^(color|colour)$/i.test(typeof option==='string'?option:option.name)),color=state.chosen[colorIndex]||'';
      const photos=this.colorPhotos(state.product,color);if(!photos.length){if(nav)nav.hidden=true;return;}
      const track=document.createElement('span');track.className='ghb-photo-track';track.setAttribute('aria-label','Fotos de '+state.product.title+' en '+color);
      photos.forEach((item,i)=>{const img=document.createElement('img'),url=new URL(item.src,location.href);url.searchParams.set('width','600');img.src=url.href;img.alt=item.alt;img.loading=i>1?'lazy':'eager';img.draggable=false;track.append(img);});
      const current=old||photo.querySelector('img');if(current)current.replaceWith(track);else photo.prepend(track);
      const count=nav.querySelector('[data-hb-photo-count]');nav.hidden=photos.length<2;
      const update=()=>{const index=Math.round(track.scrollLeft/Math.max(1,track.clientWidth));wrapper.dataset.hbGalleryIndex=String(index);count.textContent=(index+1)+' / '+photos.length;nav.querySelector('[data-hb-photo-step="-1"]').disabled=index===0;nav.querySelector('[data-hb-photo-step="1"]').disabled=index===photos.length-1;};
      track.addEventListener('scroll',update,{passive:true});update();
    });
  }
  sizeIndex(product) { return product.options.findIndex(option => /talla|size|tamaño/i.test(typeof option==='string'?option:option.name)); }
  sizeRange(value) {
    const fractions={'⅛':'1/8','¼':'1/4','⅜':'3/8','½':'1/2','⅝':'5/8','¾':'3/4','⅞':'7/8'};
    const text=String(value).replace(/[⅛¼⅜½⅝¾⅞]/g,fraction=>' '+fractions[fraction]).replace(/\s+/g,' ').trim();
    const usSizes={'6 3/8':51,'6 1/2':52,'6 5/8':53,'6 3/4':54,'6 7/8':55,'7':56,'7 1/8':57,'7 1/4':58,'7 3/8':59,'7 1/2':60,'7 5/8':61,'7 3/4':62,'7 7/8':63,'8':64};
    const usMatch=text.match(/(?:^|\s|\/)([6-8](?:\s+[1-7]\/[248])?)(?:\s*(?:-|–|a|to)\s*([6-8](?:\s+[1-7]\/[248])?))?(?=\s*(?:\/|$))/i);
    if(usMatch){const sizes=[usSizes[usMatch[1]],usSizes[usMatch[2]||usMatch[1]]];return sizes.every(Boolean)?sizes.sort((a,b)=>a-b):null;}
    const match=text.match(/(\d+(?:[.,]\d+)?)(?:\s*(?:-|–|a|to)\s*(\d+(?:[.,]\d+)?))?\s*-?\s*(cm|centimeters?|in(?:ches)?|")(?![a-z])/i);
    if(!match) {const bare=text.match(/^\d{2}$/);return bare&&Number(text)>=50&&Number(text)<=70?[Number(text),Number(text)]:null;}
    const factor=/^(?:in|")/i.test(match[3])?2.54:1;
    const sizes=[match[1],match[2]||match[1]].map(n=>Math.round(Number(n.replace(',','.'))*factor));
    return sizes.every(n=>n>=50&&n<=70)?sizes.sort((a,b)=>a-b):null;
  }
  hatSize() {
    const state=this.state.hat; if(!state?.variant) return null;
    const i=this.sizeIndex(state.product); const text=i>=0?state.variant.options[i]:state.variant.title;
    return this.sizeRange(text)?.[0]||null;
  }
  compatible(value,size) {
    if(!size) return false;
    const range=this.sizeRange(value);
    if(range)return size>=range[0]&&size<=range[1];
    const text=String(value).trim().toUpperCase();
    if(/^(CH|S|SMALL)$/.test(text)) return size>=54&&size<=56;
    if(/^(M|MEDIUM)$/.test(text)) return size>=57&&size<=59;
    if(/^(G|L|LARGE)$/.test(text)) return size>=60&&size<=62;
    return /UNITALLA|AJUSTABLE|ONE SIZE|ADJUSTABLE|DEFAULT TITLE/.test(text);
  }
  candidates(kind,state=this.state[kind]) {
    if(!state) return [];
    let variants=state.product.variants.filter(v=>v.available);
    const colorIndex=state.product.options.findIndex(option=>/^(color|colour)$/i.test(typeof option==='string'?option:option.name));
    if(colorIndex>=0&&state.chosen[colorIndex])variants=variants.filter(v=>v.options[colorIndex]===state.chosen[colorIndex]);
    if(kind==='band') {const i=this.sizeIndex(state.product); if(i>=0) variants=variants.filter(v=>this.compatible(v.options[i],this.hatSize()));}
    return variants;
  }
  resolve(kind) {
    const state=this.state[kind]; if(!state) return;
    const variants=this.candidates(kind);
    state.product.options.forEach((option,i)=>{
      if(/^(color|colour)$/i.test(typeof option==='string'?option:option.name)&&state.chosen[i])return;
      const values=[...new Set(variants.map(v=>v.options[i]))];
      if(!values.includes(state.chosen[i])) state.chosen[i]='';
      if(values.length===1 || (kind==='band' && i===this.sizeIndex(state.product))) state.chosen[i]=values[0]||'';
    });
    state.variant=variants.find(v=>v.options.every((value,i)=>value===state.chosen[i])) || null;
  }
  options(kind) {
    const panel=this.querySelector('[data-hb-options="'+kind+'"]');
    const state=this.state[kind]; panel.hidden=!state;
    if(!state){panel.replaceChildren();panel.hbProduct=null;return;}
    if(panel.hbProduct!==state.product){
      panel.replaceChildren();panel.hbProduct=state.product;
      const title=document.createElement('strong');title.textContent=state.product.title;panel.append(title);
    }
    const variants=this.candidates(kind);
    state.product.options.map((option,i)=>({option,i})).sort((a,b)=>{const rank=o=>/talla|size|tamaño/i.test(typeof o==='string'?o:o.name)?0:/material|tejido|fabric|quality|calidad/i.test(typeof o==='string'?o:o.name)?1:2;return rank(a.option)-rank(b.option);}).forEach(({option,i})=>{
      const name=typeof option==='string'?option:option.name;
      if(/^(color|colour)$/i.test(name) || (kind==='band' && i===this.sizeIndex(state.product)))return;
      const values=[...new Set(variants.map(v=>v.options[i]))];
      if(values.length===1 && values[0]==='Default Title') return;
      let select=panel.querySelector('[data-hb-option="'+i+'"]');
      if(!select){
        const field=document.createElement('div');field.className='ghb-option-field';
        const label=document.createElement('label');label.textContent=/material|tejido|fabric|quality|calidad/i.test(name)?this.t.material_label:window.GooseOptions.name(name);
        select=document.createElement('select');select.dataset.hbOption=String(i);select.dataset.hbKind=kind;select.id=this.id+'-'+kind+'-option-'+i;label.htmlFor=select.id;
        field.append(label,select);
        const isSize=/talla|size|tamaño/i.test(name),isMaterial=/material|tejido|fabric|quality|calidad/i.test(name);
        if(isSize||isMaterial){
          const link=document.createElement('button');link.type='button';link.className='ghb-option-help';link.dataset.hbHelp=isSize?'size':'material';link.textContent=isSize?this.t.size_guide:this.t.material_guide;link.setAttribute('aria-haspopup','dialog');link.setAttribute('aria-expanded','false');link.setAttribute('aria-controls',isSize?'HatbarSizeGuide':'HatbarMaterialGuide');field.append(link);
        }
        panel.append(field);
      }
      const signature=JSON.stringify(values);
      if(select.dataset.hbValues!==signature){
        select.replaceChildren(new Option(/talla|size|tamaño/i.test(name)?this.t.choose_size:/material|tejido|fabric|quality|calidad/i.test(name)?this.t.choose_material:this.t.choose,''),...values.map(value=>new Option(window.GooseOptions.value(value),value)));
        select.dataset.hbValues=signature;
      }
      for(const entry of select.options){
        const disabled=entry.value!==''&&!variants.some(v=>v.options[i]===entry.value&&state.chosen.every((chosen,j)=>j===i||!chosen||v.options[j]===chosen));
        if(entry.disabled!==disabled)entry.disabled=disabled;
      }
      const value=state.chosen[i]||'';
      if(select.value!==value)select.value=value;
      select.disabled=values.length<=1;
    });
    let note=panel.querySelector('[data-hb-option-note]');
    if(!note){note=document.createElement('p');note.dataset.hbOptionNote='';panel.append(note);}
    note.textContent=state.variant?this.money(state.variant.price):variants.length?this.t.complete:this.t.unavailable;
    if(kind==='band')panel.hidden=!!state.variant&&!panel.querySelector('[data-hb-option]');
  }
  focusHatOptions() {
    const panel=this.querySelector('[data-hb-options="hat"]');
    if(panel.hidden)return;
    panel.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'center'});
    panel.querySelector('select:not(:disabled)')?.focus({preventScroll:true});
  }
  async choose(button,showOptions=false) {
    const kind=button.dataset.hbKind;
    if(kind!=='hat'&&!this.state.hat?.variant){this.status(this.t.start);return;}
    const token=(this.tokens[kind]||0)+1;this.tokens[kind]=token;
    this.pending=(this.pending||0)+1;this.update();this.status(this.t.loading);
    try {
      const product=await this.product(button.dataset.hbUrl);
      if(this.tokens[kind]!==token) return;
      if(kind==='hat' && (!this.hatHandles.has(product.handle)||product.gift_card)) throw new Error(this.t.unavailable);
      this.state[kind]={product,url:button.dataset.hbUrl,chosen:[],variant:null};
      const colorIndex=product.options.findIndex(option=>/^(color|colour)$/i.test(typeof option==='string'?option:option.name));
      if(colorIndex>=0){
        const choices=Array.from(button.closest('.ghb-preview-card').querySelectorAll('.goose-card-colors__choice'));
        const initial=button.dataset.hbColor||choices.find(choice=>product.variants.some(v=>v.available&&v.options[colorIndex]===choice.dataset.colorName))?.dataset.colorName||choices[0]?.dataset.colorName||product.variants.find(v=>v.available)?.options[colorIndex];
        this.state[kind].chosen[colorIndex]=initial;
        choices.find(choice=>choice.dataset.colorName===initial)?.click();
      }
      this.resolve(kind);this.options(kind);
      if(kind==='hat') {this.resolve('band');this.options('band');}
      this.querySelectorAll('[data-hb-kind="'+kind+'"][data-hb-product]').forEach(card=>card.setAttribute('aria-pressed',String(card===button)));
      if(kind==='hat'){this.setupPhotos();if(showOptions)this.focusHatOptions();}
      this.status('');
    } catch(error) {this.status(error.message||this.t.load_error);}
    finally {this.pending--;this.update();}
  }
  async engraving() {
    const toggle=this.querySelector('[data-hb-engrave]');const active=toggle.checked;
    this.querySelector('[data-hb-engraving-panel]').hidden=!active;toggle.setAttribute('aria-expanded',String(active));
    if(active&&!this.service) {
      this.pending=(this.pending||0)+1;this.update();
      try {const product=await this.product(this.dataset.engravingUrl);this.service={product,url:this.dataset.engravingUrl,variant:product.variants.find(v=>v.available)};if(!this.service.variant) throw new Error(this.t.engraving_unavailable);this.querySelector('[data-hb-engrave-price]').textContent='+ '+this.money(this.service.variant.price);}
      catch(error){toggle.checked=false;this.querySelector('[data-hb-engraving-panel]').hidden=true;toggle.setAttribute('aria-expanded','false');this.service=null;this.status(error.message);}
      finally{this.pending--;}
    }
    this.update();
  }
  position() {return this.querySelector('[data-hb-position]:checked')?.value||'';}
  engravingActive() {return this.querySelector('[data-hb-engrave]').checked;}
  initials() {return this.querySelector('[data-hb-initials]').value.trim();}
  valid() {
    return !!this.state.hat?.variant && ['band','feather'].every(k=>!this.state[k]||this.state[k].variant) && (!this.engravingActive() || (!!this.service?.variant&&/^[A-Z0-9]{1,3}$/.test(this.initials())&&!!this.position()));
  }
  total() {return Object.values(this.state).reduce((sum,s)=>sum+(s?.variant?.price||0),0)+(this.engravingActive()?(this.service?.variant?.price||0):0);}
  updateDelivery() {
    const delivery=this.querySelector('[data-hb-delivery]');
    if(!delivery)return;
    const config=JSON.parse(delivery.querySelector('[data-delivery-config]').textContent);
    const selections=Object.values(this.state).filter(state=>state?.product);
    const items=selections.length?selections.map(state=>{
      const product=config.products.find(item=>String(item.id)===String(state.product.id));
      return product?{...product,variant:state.variant?.id||product.variant}:null;
    }).filter(Boolean):[config.products[0]].filter(Boolean);
    const key=items.map(item=>item.id+':'+item.variant).join('|');
    if(this.deliveryKey===key)return;
    this.deliveryKey=key;
    const next=delivery.cloneNode(true);
    next.querySelector('[data-delivery-config]').textContent=JSON.stringify({...config,items});
    next.querySelector('[data-delivery-estimate]').textContent=config.pending;
    const title=this.state.hat?.product.title||config.defaultTitle;
    const link=next.querySelector('a');
    link.href='https://wa.me/527223538434?text='+encodeURIComponent(config.expressMessage.replace('__product__',title));
    link.textContent=config.express;
    delete next.dataset.state;
    delete next.dataset.minimum;
    delete next.dataset.maximum;
    next.hidden=false;
    delivery.replaceWith(next);
  }
  update() {
    const list=this.querySelector('[data-hb-lines]');list.replaceChildren();
    const line=(title,detail,price,kind)=>{
      const item=document.createElement('li'),name=document.createElement('span'),amount=document.createElement('strong'),small=document.createElement('small');
      name.textContent=title;amount.textContent=price==null?'—':this.money(price);small.textContent=detail;item.append(name,amount,small);
      if(kind) {const button=document.createElement('button');button.type='button';button.dataset.hbRemove=kind;button.textContent=this.t.remove;item.append(button);}list.append(item);
    };
    for(const kind of ['hat','band','feather']) {const s=this.state[kind];if(s) line(s.product.title,s.variant&&s.variant.title!=='Default Title'?window.GooseOptions.variant(s.variant.title):s.variant?'':this.t.complete,s.variant?.price,kind==='hat'?null:kind);}
    if(this.engravingActive()) line(this.t.engraving,[this.initials(),this.t[this.position()]].filter(Boolean).join(' · '),this.service?.variant?.price,'engraving');
    this.querySelector('[data-hb-empty]').hidden=!!this.state.hat;
    const ready=this.valid()&&!this.pending;
    this.querySelectorAll('[data-hb-total]').forEach(el=>el.textContent=ready?this.money(this.total()):'—');
    this.querySelectorAll('[data-hb-add]').forEach(button=>button.disabled=!ready||this.busy||this.locked);
    this.querySelectorAll('[data-hb-product]').forEach(button=>{
      if(!button.hasAttribute('data-hb-original-disabled')) button.dataset.hbOriginalDisabled=String(button.disabled);
      button.disabled=button.dataset.hbOriginalDisabled==='true'||this.busy||this.locked||(button.dataset.hbKind!=='hat'&&!this.state.hat?.variant);
    });
    this.querySelectorAll('[data-hb-choose]').forEach(button=>{
      const card=button.closest('.ghb-preview-card').querySelector('[data-hb-product]');
      const selected=this.state.hat?.product.handle===card.dataset.hbProduct;
      const label=selected?this.t.selected_hat:this.t.choose_hat;
      button.disabled=card.disabled||!!this.pending;
      button.setAttribute('aria-expanded',String(selected));
      button.setAttribute('aria-label',label+': '+card.querySelector('strong').textContent);
      button.querySelector('[data-hb-choose-label]').textContent=label;
    });
    this.classList.toggle('is-busy',this.busy);
    this.updateDelivery();
  }
  remove(kind) {
    if(kind==='engraving'){this.querySelector('[data-hb-engrave]').checked=false;this.engraving();return;}
    this.tokens[kind]=(this.tokens[kind]||0)+1;this.state[kind]=null;this.options(kind);
    this.querySelectorAll('[data-hb-product][data-hb-kind="'+kind+'"]').forEach(button=>button.setAttribute('aria-pressed','false'));this.update();
  }
  openHelp(kind,opener) {
    this.helpDialogs ||= new Map();
    let dialog=this.helpDialogs.get(kind);
    if(!dialog){
      const id=kind==='size'?'HatbarSizeGuide':'HatbarMaterialGuide';
      const template=this.querySelector('#'+id+'Template');if(!template)return;
      dialog=template.content.firstElementChild.cloneNode(true);document.body.append(dialog);this.helpDialogs.set(kind,dialog);
      dialog.querySelectorAll('a').forEach(link=>{
        const path=new URL(link.href,location.href).pathname;
        if(path===new URL(this.dataset.sizeGuideUrl,location.href).pathname)link.dataset.hbHelp='size';
        else if(path===new URL(this.dataset.materialGuideUrl,location.href).pathname)link.dataset.hbHelp='material';
        else {link.target='_blank';link.rel='noopener';}
      });
      dialog.addEventListener('click',event=>{
        const help=event.target.closest('[data-hb-help]');
        if(help){event.preventDefault();const returnTo=dialog.hbOpener;dialog.close();this.openHelp(help.dataset.hbHelp,returnTo);return;}
        if(event.target.closest('[data-size-guide-close]')){dialog.close();return;}
        if(event.target===dialog){const bounds=dialog.getBoundingClientRect();if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)dialog.close();}
      });
      dialog.addEventListener('close',()=>{
        dialog.classList.remove('is-visible');dialog.hbOpener?.setAttribute('aria-expanded','false');
        if(!Array.from(this.helpDialogs.values()).some(item=>item.open)){document.documentElement.classList.remove('goose-size-guide-open');if(dialog.hbOpener?.isConnected)dialog.hbOpener.focus({preventScroll:true});}
      });
    }
    if(dialog.open)return;
    if(kind==='material'&&this.state.hat){
      const product=this.state.hat.product,i=product.options.findIndex(option=>/material|tejido|fabric|quality|calidad/i.test(typeof option==='string'?option:option.name));
      const materials=i>=0?product.variants.map(variant=>variant.options[i]).join(' ').toLowerCase():'';
      const shown={wool:/lana|wool/.test(materials),rabbit:/conejo|rabbit/.test(materials),beaver:/castor|beaver/.test(materials)};
      dialog.querySelectorAll('.goose-material-guide__card').forEach(card=>{const key=card.querySelector('h3').id.split('-').pop();card.hidden=!shown[key];});
      const quality=dialog.querySelector('.goose-size-guide__body>.goose-material-guide__description');if(quality)quality.hidden=!shown.wool;
      const order=dialog.querySelector('.goose-material-guide__order');if(order)order.hidden=!shown.beaver;
    }
    dialog.hbOpener=opener;opener?.setAttribute('aria-expanded','true');document.documentElement.classList.add('goose-size-guide-open');dialog.showModal();
    dialog.querySelector('[data-size-guide-close]').focus({preventScroll:true});
    requestAnimationFrame(()=>{if(dialog.open)dialog.classList.add('is-visible');});
  }
  onClick(event) {
    const wornToggle=event.target.closest('[data-hb-worn-toggle]');
    if(wornToggle){event.preventDefault();const wrapper=wornToggle.closest('.ghb-preview-card');this.setWornPhoto(wrapper,!wrapper.hasAttribute('data-hb-worn-active'));return;}
    const photoArrow=event.target.closest('[data-hb-photo-step]');
    if(photoArrow){event.preventDefault();const wrapper=photoArrow.closest('.ghb-preview-card');this.setWornPhoto(wrapper,false);const track=wrapper.querySelector('.ghb-photo-track');if(track)track.scrollBy({left:Number(photoArrow.dataset.hbPhotoStep)*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});return;}
    if(event.target.closest('.ghb-photo-track'))return;
    const help=event.target.closest('[data-hb-help]');if(help){event.preventDefault();this.openHelp(help.dataset.hbHelp,help);return;}
    const preview=event.target.closest('.ghb-preview-card .goose-card-colors__choice');
    if(this.busy||this.locked){if(preview){event.preventDefault();event.stopPropagation();}return;}
    const chooseButton=event.target.closest('[data-hb-choose]');
    if(chooseButton){
      if(chooseButton.disabled||this.pending)return;
      const card=chooseButton.closest('.ghb-preview-card').querySelector('[data-hb-product]');
      if(this.state.hat?.product.handle===card.dataset.hbProduct)this.focusHatOptions();
      else this.choose(card,true);
      return;
    }
    if(preview){
      const button=preview.closest('.ghb-preview-card').querySelector('[data-hb-product]');
      button.dataset.hbColor=preview.dataset.colorName;
      if(button.dataset.hbKind==='hat')this.updateWornPhoto(button);
      const kind=button.dataset.hbKind,state=this.state[kind];
      if(state?.product.handle===button.dataset.hbProduct){
        const i=state.product.options.findIndex(option=>/^(color|colour)$/i.test(typeof option==='string'?option:option.name));
        if(i>=0){state.chosen[i]=button.dataset.hbColor;this.resolve(kind);this.options(kind);if(kind==='hat'){this.resolve('band');this.options('band');}this.status('');this.update();if(kind==='hat')queueMicrotask(()=>this.setupPhotos());}
      }
      return;
    }
    const card=event.target.closest('[data-hb-product]');if(card){this.choose(card);return;}
    const remove=event.target.closest('[data-hb-remove]');if(remove){this.remove(remove.dataset.hbRemove);return;}
    const arrow=event.target.closest('[data-hb-scroll]');if(arrow){const rail=arrow.closest('[data-hb-step]').querySelector('.ghb-rail');rail.scrollBy({left:Number(arrow.dataset.hbScroll)*rail.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});return;}
    if(event.target.closest('[data-hb-review]')){const summary=this.querySelector('[data-hb-summary]');summary.scrollIntoView({behavior:'smooth',block:'center'});summary.focus({preventScroll:true});return;}
    if(event.target.closest('[data-hb-add]'))this.add();
  }
  onChange(event) {
    if(this.busy||this.locked)return;
    const select=event.target.closest('[data-hb-option]');
    if(select){const kind=select.dataset.hbKind;this.state[kind].chosen[Number(select.dataset.hbOption)]=select.value;this.resolve(kind);this.options(kind);if(kind==='hat'){this.resolve('band');this.options('band');}this.status('');this.update();
      const state=this.state[kind],i=Number(select.dataset.hbOption),option=state.product.options[i];
      if(/^(color|colour)$/i.test(typeof option==='string'?option:option.name)){
        const card=Array.from(this.querySelectorAll('[data-hb-product]')).find(button=>button.dataset.hbKind===kind&&button.dataset.hbProduct===state.product.handle);
        const choice=card&&Array.from(card.closest('.ghb-preview-card').querySelectorAll('.goose-card-colors__choice')).find(button=>button.dataset.colorName===select.value);
        if(choice)choice.click();
      }
      return;}
    if(event.target.matches('[data-hb-engrave]'))this.engraving();
    else if(event.target.matches('[data-hb-position]'))this.update();
  }
  payload(linkId) {
    const hat=this.state.hat; const properties={_Personalizacion_ID:linkId,_Origen:'HATBAR'};
    if(this.engravingActive()){properties[this.t.engraving_label]=this.initials();properties[this.t.position_label]=this.t[this.position()];}
    if(this.state.band){properties[this.t.band_label]=this.state.band.product.title;properties[this.t.band_detail_label]=window.GooseOptions.variant(this.state.band.variant.title);}
    if(this.state.feather){properties[this.t.feather_label]=this.state.feather.product.title;properties[this.t.feather_detail_label]=window.GooseOptions.variant(this.state.feather.variant.title);}
    const items=[{id:hat.variant.id,quantity:1,properties}];
    for(const kind of ['band','feather']){const s=this.state[kind];if(s)items.push({id:s.variant.id,quantity:1,properties:{_Complemento:kind==='band'?'Toquilla adicional':'Pluma adicional',_Sombrero:hat.product.title,_Personalizacion_ID:linkId}});}
    if(this.engravingActive())items.push({id:this.service.variant.id,quantity:1,properties:{_Servicio:'Grabado personalizado',_Grabado:this.initials(),_Personalizacion_ID:linkId}});
    return {items};
  }
  async add() {
    if(this.busy||this.locked||!this.valid()||this.pending)return;
    this.busy=true;this.update();this.status(this.t.adding);
    let posted=false;let linkId='';
    try {
      const selections=Object.entries(this.state).filter(([,s])=>s);
      if(this.engravingActive())selections.push(['engraving',this.service]);
      const fresh=await Promise.all(selections.map(async([kind,s])=>({kind,state:s,product:await this.product(s.url,true)})));
      let changed=false,unavailable=false;
      for(const {kind,state,product} of fresh){const variant=product.variants.find(v=>v.id===state.variant.id&&v.available);state.product=product;if(!variant||(kind==='hat'&&(!this.hatHandles.has(product.handle)||product.gift_card))){state.variant=null;unavailable=true;continue;}if(variant.price!==state.variant.price)changed=true;state.variant=variant;}
      for(const kind of ['hat','band','feather'])this.options(kind);
      if(this.service?.variant)this.querySelector('[data-hb-engrave-price]').textContent='+ '+this.money(this.service.variant.price);
      if(unavailable)throw new Error(this.t.unavailable);
      if(changed)throw new Error(this.t.price_changed);
      linkId='HATBAR-'+crypto.randomUUID();const payload=this.payload(linkId);
      this.deliveryKey='';this.updateDelivery();
      const delivery=this.querySelector('[data-hb-delivery]');
      if(!delivery?.captureProperties)throw new Error('No se pudo confirmar la fecha de entrega. Intenta nuevamente antes de agregar.');
      const promises=await delivery.captureProperties();
      if(delivery.dataset.country==='MX')for(const item of payload.items){
        if(item.properties?._Servicio==='Grabado personalizado')continue;
        const promise=promises[String(item.id)];
        if(!promise)throw new Error('Falta confirmar la fecha de una pieza. Revisa tu selección antes de agregar.');
        item.properties={...item.properties,...promise};
      }
      const cartDrawer=document.querySelector('cart-drawer');
      if(cartDrawer){payload.sections=cartDrawer.getSectionsToRender().map(section=>section.id);payload.sections_url=location.pathname;cartDrawer.setActiveElement(this.querySelector('[data-hb-add]'));}
      posted=true;
      const response=await fetch(this.route('cart/add.js'),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)});
      const result=await response.json();
      if(!response.ok)throw new Error(typeof result.description==='string'?result.description:this.t.cart_error);
      const cartResponse=await fetch(this.route('cart.js'),{credentials:'same-origin',cache:'no-store'});
      if(!cartResponse.ok)throw new Error(this.t.uncertain);
      const cart=await cartResponse.json();const group=cart.items.filter(item=>item.properties?._Personalizacion_ID===linkId);
      if(!payload.items.every(item=>group.some(line=>line.variant_id===item.id&&line.quantity===item.quantity)))throw new Error(this.t.uncertain);
      this.locked=true;this.status(this.t.added);this.querySelector('[data-hb-cart-link]').hidden=false;
      if(cartDrawer){try{cartDrawer.renderContents(result);}catch(renderError){location.assign(this.dataset.cart);}}
      else location.assign(this.dataset.cart);
    } catch(error) {
      if(posted){this.locked=true;this.querySelector('[data-hb-cart-link]').hidden=false;this.status(this.t.uncertain);}
      else this.status(error.message||this.t.cart_error);
    } finally {this.busy=false;this.update();}
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["goose-hero-atmosphere"] && !Shopify.designMode) return;
  try {
    (() => {
  const controllers = new Map();
  const setup = (scope) => {
    const roots = scope.matches?.('[data-gwh-hero-motion]') ? [scope] : scope.querySelectorAll('[data-gwh-hero-motion]');
    roots.forEach((root) => {
      if (controllers.has(root)) return;
      const image = root.querySelector('.gwh-hero__image');
      const video = root.querySelector('[data-hero-film]');
      if (!image || !video) return;
      const mobile = matchMedia('(max-width: 749px)');
      const bounds = root.getBoundingClientRect();
      let inView = bounds.bottom > 0 && bounds.top < innerHeight;
      let failed = false;
      let blocked = false;
      let pending = false;
      let disposed = false;
      let idle;
      video.defaultMuted = true;
      video.muted = true;
      video.autoplay = true;
      video.loop = true;
      video.controls = false;
      const allowed = () => !disposed && !failed && inView && !document.hidden;
      const play = () => {
        if (!allowed() || blocked || pending || !video.paused || !video.hasAttribute('src')) return;
        pending = true;
        video.play().then(() => {
          pending = false;
          if (!allowed()) video.pause();
        }).catch((error) => {
          pending = false;
          if (error.name === 'AbortError') { if (allowed()) requestAnimationFrame(play); return; }
          if (!allowed()) return;
          blocked = true;
        });
      };
      const loadVideo = () => {
        idle = undefined;
        if (!allowed() || !image.complete || image.naturalWidth === 0) return;
        const source = mobile.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
        if (video.getAttribute('src') !== source) {
          root.classList.remove('is-hero-film-ready');
          video.src = source;
        }
        play();
      };
      const render = () => {
        if (!allowed()) video.pause();
        else if (video.hasAttribute('src')) play();
        else if (image.complete && image.naturalWidth > 0 && idle === undefined) {
          if ('requestIdleCallback' in window) idle = requestIdleCallback(loadVideo, { timeout: 1000 });
          else loadVideo();
        }
      };
      const onPlaying = () => {
        if (!allowed()) { video.pause(); return; }
        blocked = false;
        root.classList.add('is-hero-film-ready');
      };
      const onError = () => {
        failed = true;
        root.classList.remove('is-hero-film-ready');
        render();
      };
      const onInteraction = () => {
        if (!blocked) return;
        blocked = false;
        render();
      };
      const onReturn = () => { blocked = false; render(); };
      const onSize = () => {
        if (!video.hasAttribute('src')) return;
        video.pause();
        video.removeAttribute('src');
        root.classList.remove('is-hero-film-ready');
        failed = false;
        blocked = false;
        loadVideo();
      };
      const observer = new IntersectionObserver((entries) => { inView = entries[0].isIntersecting; render(); }, { threshold: .01 });
      video.addEventListener('playing', onPlaying);
      video.addEventListener('error', onError);
      image.addEventListener('load', render);
      mobile.addEventListener('change', onSize);
      document.addEventListener('visibilitychange', onReturn);
      document.addEventListener('pointerdown', onInteraction, { passive: true });
      document.addEventListener('touchend', onInteraction, { passive: true });
      document.addEventListener('keydown', onInteraction);
      window.addEventListener('pageshow', onReturn);
      observer.observe(root);
      controllers.set(root, () => {
        disposed = true;
        if (idle !== undefined && 'cancelIdleCallback' in window) cancelIdleCallback(idle);
        observer.disconnect();
        video.pause();
        video.removeAttribute('src');
        video.load();
        video.removeEventListener('playing', onPlaying);
        video.removeEventListener('error', onError);
        image.removeEventListener('load', render);
        mobile.removeEventListener('change', onSize);
        document.removeEventListener('visibilitychange', onReturn);
        document.removeEventListener('pointerdown', onInteraction);
        document.removeEventListener('touchend', onInteraction);
        document.removeEventListener('keydown', onInteraction);
        window.removeEventListener('pageshow', onReturn);
        controllers.delete(root);
      });
      render();
    });
  };
  setup(document);
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [root, dispose] of controllers) if (event.target.contains(root)) dispose();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["goose-home-shopping"] && !Shopify.designMode) return;
  try {
    (() => {
  const instances = new Map();
  const setup = (scope) => {
    const roots = scope.matches?.('.gwh-shopping--showcase') ? [scope] : scope.querySelectorAll('.gwh-shopping--showcase');
    roots.forEach((root) => {
      if (instances.has(root)) return;
      const abort = new AbortController();
      const cleanups = [];
      root.querySelectorAll('[data-panel]').forEach((panel) => {
        const rail = panel.querySelector('.gwh-rail');
        const status = panel.querySelector('[data-model-count]');
        const previous = panel.querySelector('[data-scroll="-1"]');
        const next = panel.querySelector('[data-scroll="1"]');
        let frame = 0;
        const update = () => {
          frame = 0;
          if (!rail.clientWidth) return;
          const cards = [...rail.querySelectorAll('.gwh-card')];
          const bounds = rail.getBoundingClientRect();
          const visible = cards.map((card, index) => {
            const box = card.getBoundingClientRect();
            return Math.min(box.right, bounds.right) - Math.max(box.left, bounds.left) >= box.width * .5 ? index + 1 : 0;
          }).filter(Boolean);
          const first = visible[0] || 1;
          const last = visible[visible.length - 1] || first;
          const template = first === last ? root.dataset.counterSingle : root.dataset.counterTemplate;
          const text = template.replace('[first]', first).replace('[last]', last).replace('[total]', cards.length);
          if (status.textContent !== text) status.textContent = text;
          previous.disabled = rail.scrollLeft <= 2;
          next.disabled = rail.scrollWidth - rail.clientWidth - rail.scrollLeft <= 2;
        };
        const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
        rail.addEventListener('scroll', schedule, { passive: true, signal: abort.signal });
        const observer = new ResizeObserver(schedule);
        observer.observe(rail);
        schedule();
        cleanups.push(() => { observer.disconnect(); cancelAnimationFrame(frame); });
      });
      instances.set(root, () => { abort.abort(); cleanups.forEach(cleanup => cleanup()); });
    });
  };
  const start = () => setup(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((cleanup, root) => {
      if (event.target.contains(root)) { cleanup(); instances.delete(root); }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["goose-palma-menu-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  let closeTimer;
  const previewLinks = () => document.querySelectorAll('.goose-palma-menu-link');
  const positionPreview = (link) => {
    const preview = link.querySelector('.goose-palma-menu-preview');
    if (!preview) return;
    const anchor = link.getBoundingClientRect();
    const header = link.closest('.section-header');
    const top = Math.max(anchor.bottom, header?.getBoundingClientRect().bottom || anchor.bottom);
    preview.style.setProperty('--palma-preview-top', `${top - anchor.top}px`);
    preview.style.setProperty('--palma-preview-viewport-top', `${top}px`);
    preview.style.setProperty('--palma-preview-offset', '0px');
    const bounds = preview.getBoundingClientRect();
    if (!bounds.width) return;
    const width = document.documentElement.clientWidth;
    const offset = Math.max(16, Math.min(bounds.left, width - bounds.width - 16)) - bounds.left;
    preview.style.setProperty('--palma-preview-offset', `${offset}px`);
  };
  const openPreview = (link) => {
    clearTimeout(closeTimer);
    previewLinks().forEach(other => { if (other !== link) other.classList.remove('is-palma-preview-open'); });
    link.classList.remove('preview-dismissed');
    link.classList.add('is-palma-preview-open');
    positionPreview(link);
  };
  document.addEventListener('pointerover', event => {
    if (event.pointerType === 'touch') return;
    const link = event.target.closest('.goose-palma-menu-link');
    if (link && !link.contains(event.relatedTarget)) openPreview(link);
  });
  document.addEventListener('pointerout', event => {
    const link = event.target.closest('.goose-palma-menu-link');
    if (link && !link.contains(event.relatedTarget)) {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => link.classList.remove('is-palma-preview-open'), 250);
    }
  });
  document.addEventListener('focusin', event => {
    const link = event.target.closest('.goose-palma-menu-link');
    if (link) openPreview(link);
  });
  document.addEventListener('focusout', event => {
    const link = event.target.closest('.goose-palma-menu-link');
    if (link && !link.contains(event.relatedTarget)) link.classList.remove('is-palma-preview-open');
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    clearTimeout(closeTimer);
    previewLinks().forEach(link => {
      link.classList.add('preview-dismissed');
      link.classList.remove('is-palma-preview-open');
    });
  });
  const reposition = () => previewLinks().forEach(link => {
    if (link.classList.contains('is-palma-preview-open')) positionPreview(link);
  });
  window.addEventListener('resize', reposition);
  window.addEventListener('scroll', reposition, {passive:true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["goose-product-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('goose-product-preview')) {
  customElements.define('goose-product-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.frame) return;
      this.frame = this.parentElement;
      this.frame.classList.add('goose-product-preview-frame');
      this.card = this.frame.closest('.card-wrapper, .gwh-card, .gw-john__card, .gsv-card');
      if (this.card?.matches('.card-wrapper') && !this.frame.querySelector('a')) {
        this.link = document.createElement('a');
        this.link.className = 'goose-product-preview__link';
        this.link.href = this.dataset.url;
        this.link.setAttribute('aria-label', this.dataset.title);
        this.link.tabIndex = -1;
        const label = document.createElement('span');
        label.className = 'visually-hidden';
        label.textContent = this.dataset.title;
        this.link.append(label);
        this.frame.append(this.link);
      }
      if (this.dataset.product === 'gobernador') {
        this.resizeObserver = new ResizeObserver(() => this.centerSubject());
        this.resizeObserver.observe(this.frame);
      }
      this.controls = this.frame.querySelector('.goose-preview-controls') || this.controls;
      if (this.controls) {
        this.controls.setAttribute('data-preview-ready', '');
      }
      this.updateControls();
      this.photo = this.querySelector('img');
      this.preloadObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.photo.loading = 'eager';
          this.photo.decode().catch(() => {});
          this.preloadObserver.disconnect();
        }
      }, {rootMargin:'250px'});
      this.preloadObserver.observe(this.frame);
      this.onStart = event => {
        this.swiped = false;
        this.gesture = !this.frame.closest('[data-goose-carousel]') && event.touches.length === 1 && !event.target.closest('.goose-preview-controls button')
          ? {x:event.touches[0].clientX,y:event.touches[0].clientY,axis:null} : null;
      };
      this.onMove = event => {
        if (!this.gesture || event.touches.length !== 1) {this.gesture = null;return;}
        const dx = event.touches[0].clientX - this.gesture.x;
        const dy = event.touches[0].clientY - this.gesture.y;
        if (!this.gesture.axis && Math.max(Math.abs(dx),Math.abs(dy)) > 8) {
          if (Math.abs(dx) > Math.abs(dy) * 1.15) this.gesture.axis = 'horizontal';
          else if (Math.abs(dy) > 16 && Math.abs(dy) > Math.abs(dx) * 1.4) this.gesture.axis = 'vertical';
        }
        if (this.gesture.axis === 'horizontal') {event.preventDefault();event.stopPropagation();}
      };
      this.onEnd = event => {
        if (!this.gesture || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - this.gesture.x;
        const dy = event.changedTouches[0].clientY - this.gesture.y;
        const axis = this.gesture.axis;
        this.gesture = null;
        const threshold = Math.min(30,Math.max(18,this.frame.clientWidth * .1));
        if (axis !== 'vertical' && Math.abs(dx) >= threshold && Math.abs(dx) > Math.abs(dy) * 1.15) {
          event.preventDefault();event.stopPropagation();
          this.swiped = true;
          this.setActive(dx > 0);
        }
      };
      this.onCancel = () => {this.gesture = null;};
      this.onClick = event => {
        if (event.target.closest('.goose-preview-controls button')) return;
        if (this.swiped) {event.preventDefault();event.stopPropagation();this.swiped = false;}
      };
      this.onControlClick = event => {
        if (event.target.closest('button')) {
          event.preventDefault();event.stopPropagation();
          this.setActive(!this.frame.hasAttribute('data-preview-active'));
        }
      };
      this.onColor = event => {
        if (event.target.closest('.goose-card-colors__choice')) this.setActive(false);
      };
      this.frame.addEventListener('touchstart',this.onStart,{passive:true});
      this.frame.addEventListener('touchmove',this.onMove,{passive:false});
      this.frame.addEventListener('touchend',this.onEnd,{passive:false});
      this.frame.addEventListener('touchcancel',this.onCancel);
      this.frame.addEventListener('click',this.onClick,true);
      this.controls?.addEventListener('click',this.onControlClick);
      this.card?.addEventListener('click', this.onColor);
    }
    setActive(active) {
      this.frame.toggleAttribute('data-preview-active',active);
      this.updateControls();
    }
    updateControls() {
      if (!this.controls) return;
      const active = this.frame.hasAttribute('data-preview-active');
      this.controls.querySelector('button').setAttribute('aria-pressed', String(active));
      this.controls.querySelector('[data-preview-label]').textContent = active ? this.controls.dataset.backLabel : this.controls.dataset.showLabel;
      this.controls.querySelectorAll('[data-preview-dot]').forEach(dot => dot.toggleAttribute('data-current',Number(dot.dataset.previewDot) === Number(active)));
      this.controls.querySelector('.goose-preview-status').textContent = active ? this.controls.dataset.previewLabel : this.controls.dataset.productLabel;
    }
    centerSubject() {
      const photo = this.querySelector('img');
      const width = this.frame.clientWidth;
      const height = this.frame.clientHeight;
      if (!photo || !width || !height) return;
      const originalWidth = Number(photo.getAttribute('width'));
      const originalHeight = Number(photo.getAttribute('height'));
      if (!originalWidth || !originalHeight) return;
      const focusX = .68;
      const scale = Math.max(width / originalWidth, height / originalHeight, width / (2 * originalWidth * (1 - focusX)));
      const photoWidth = originalWidth * scale;
      const photoHeight = originalHeight * scale;
      Object.assign(photo.style, {
        width: photoWidth + 'px', height: photoHeight + 'px',
        left: (width / 2 - photoWidth * focusX) + 'px', top: '0px', right: 'auto', bottom: 'auto'
      });
    }
    disconnectedCallback() {
      if (!this.frame) return;
      this.frame.removeEventListener('touchstart', this.onStart);
      this.frame.removeEventListener('touchmove', this.onMove);
      this.frame.removeEventListener('touchend', this.onEnd);
      this.frame.removeEventListener('touchcancel', this.onCancel);
      this.frame.removeEventListener('click', this.onClick, true);
      this.controls?.removeEventListener('click', this.onControlClick);
      this.card?.removeEventListener('click', this.onColor);
      this.resizeObserver?.disconnect();
      this.preloadObserver?.disconnect();
      this.link?.remove();
      this.frame = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["goose-story-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('goose-story-gallery')) {
    customElements.define('goose-story-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        const on = (type, fn, options = {}) => this.addEventListener(type, fn, { ...options, signal:this.events.signal });
        this.photos = JSON.parse(this.querySelector('[data-gallery-images]').textContent);
        this.image = this.querySelector('.goose-story-gallery__photo');
        this.coverSrcset = this.image.getAttribute('srcset');
        this.index = 0;
        this.updateCounter();
        on('click', event => {
          if (event.target.closest('.goose-story-gallery__next')) this.show(this.index + 1);
          if (event.target.closest('.goose-story-gallery__prev')) this.show(this.index - 1);
        });
        on('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();event.stopPropagation();this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
        on('touchstart', event => {
          this.touch = event.touches.length === 1 ? {x:event.touches[0].clientX,y:event.touches[0].clientY} : null;
        }, {passive:true});
        on('touchmove', event => {
          if (!this.touch || event.touches.length !== 1) { this.touch = null; return; }
          const dx = event.touches[0].clientX - this.touch.x, dy = event.touches[0].clientY - this.touch.y;
          if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy) * 1.3) {event.preventDefault();event.stopPropagation();}
        }, {passive:false});
        on('touchcancel', () => {this.touch = null;});
        on('touchend', event => {
          if (!this.touch || !event.changedTouches.length) return;
          const dx = event.changedTouches[0].clientX - this.touch.x, dy = event.changedTouches[0].clientY - this.touch.y;
          this.touch = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {
            event.preventDefault();event.stopPropagation();this.show(this.index + (dx > 0 ? 1 : -1));
          }
        }, {passive:false});
      }
      updateCounter() {this.querySelector('.goose-story-gallery__counter').textContent = `${this.index + 1} / ${this.photos.length}`;}
      show(index) {
        this.index = (index + this.photos.length) % this.photos.length;
        this.classList.toggle('is-additional', this.index !== 0);
        this.image.removeAttribute('srcset');
        this.image.src = this.photos[this.index].src;
        this.image.alt = this.photos[this.index].alt;
        if (this.index === 0 && this.coverSrcset) this.image.setAttribute('srcset', this.coverSrcset);
        this.updateCounter();
      }
      disconnectedCallback() {this.events?.abort();this.events = null;}
    });
  }
  } catch(e) { console.error(e); }
})();

})();
